import React from "react";
import styles from "./PaginationFooter.module.css";
import { themeColors } from "../theme";

interface PaginationFooterProps {
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    pageSize: number;
    setPageSize: React.Dispatch<React.SetStateAction<number>>;
    totalCount: number;
    isLastPage: boolean;
    pageSizeOptions?: number[];
    footerStyles?: React.CSSProperties;
}

const PaginationFooter: React.FC<PaginationFooterProps> = ({
    page,
    setPage,
    pageSize,
    setPageSize,
    totalCount,
    isLastPage,
    pageSizeOptions = [10, 25, 50, 100],
    footerStyles = {},
}) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                alignItems: "center",
                borderRadius: "0.5rem",
                padding: "1rem 0.5rem 1rem 0.5rem",
                // padding: "0.5rem",
                marginTop: "1rem",
                marginBottom: "-1rem",
                backgroundColor: themeColors.thBackgroundColor,
                color: themeColors.textPrimary,
                ...footerStyles,
            }}
        >
            <div className={styles.footer_table}>
                <div />

                <div>
                    <span>
                        Page <strong>{page}</strong>
                    </span>

                    <select
                        className={styles.dropDownSelecct}
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                    >
                        {pageSizeOptions.map((size) => (
                            <option key={size} value={size}>
                                Show {size}
                            </option>
                        ))}
                    </select>

                    <button
                        className={styles.addBox}
                        onClick={() => page > 1 && setPage(page - 1)}
                        style={page === 1 ? { backgroundColor: "#ced4da" } : {}}
                        disabled={page === 1}
                    >
                        Previous
                    </button>

                    <button
                        className={styles.addBox}
                        onClick={() => !isLastPage && setPage(page + 1)}
                        style={isLastPage ? { backgroundColor: "#ced4da" } : {}}
                        disabled={isLastPage}
                    >
                        Next
                    </button>
                </div>

                <div>
                    <p style={{ marginRight: "20px" }} className={styles.countHead}>
                        Total Records: {totalCount}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaginationFooter;